import LocalizedStrings from 'localized-strings';

// TODO(LED-1888): en locales
const locales = new LocalizedStrings({
  en: {
    description:
      'Sélectionnez l’entreprise pour laquelle vous souhaitez reprendre les démarches.',
    multiOnboardingInfo:
      'Vous pourrez ouvrir un second dossier, une fois vos documents personnels validés',
    newApplication: {
      sectionHeader: 'Créer une nouvelle société',
      subtitle: 'Vous avez un mandat de votre client•e',
      title: 'Ouvrir un nouveau dossier',
    },
    next: 'Next',
    pendingApplications: {
      defaultCompanyName: 'New company',
      pending: 'En cours de création',
      requiresBeneficiariesAction:
        'Une action d’un•e bénéficiaire est nécessaire',
      requiresMandateeAction: 'Une action de votre part est nécessaire',
      sectionHeader: 'Finaliser la création ({numberOfApplications})',
    },
    refusedApplications: {
      sectionHeader: 'Refused accounts ({numberOfApplications})',
      subtitle: 'Refused account',
    },
    title: 'Hello {firstName},',
    validatedApplications: {
      sectionHeader: 'Comptes Créés ({numberOfApplications})',
      subtitle: 'Compte ouvert',
    },
  },
  fr: {
    description:
      'Sélectionnez l’entreprise pour laquelle vous souhaitez reprendre les démarches.',
    multiOnboardingInfo:
      'Vous pourrez ouvrir un second dossier, une fois vos documents personnels validés',
    newApplication: {
      sectionHeader: 'Créer une nouvelle société',
      subtitle: 'Vous avez un mandat de votre client•e',
      title: 'Ouvrir un nouveau dossier',
    },
    next: 'Suivant',
    pendingApplications: {
      defaultCompanyName: 'Nouvelle entreprise',
      pending: 'En cours de création',
      requiresBeneficiariesAction:
        'Une action d’un•e bénéficiaire est nécessaire',
      requiresMandateeAction: 'Une action de votre part est nécessaire',
      sectionHeader: 'Finaliser la création ({numberOfApplications})',
    },
    refusedApplications: {
      sectionHeader: 'Comptes refusés ({numberOfApplications})',
      subtitle: 'Compte refusé',
    },
    title: 'Bonjour {firstName},',
    validatedApplications: {
      sectionHeader: 'Comptes Créés ({numberOfApplications})',
      subtitle: 'Compte ouvert',
    },
  },
} as const);

export default locales;
